module.exports = __webpack_public_path__ + "img/coupon_frame3.74e568b4.png";